import React from 'react';
import StatusPage from './components/StatusPage';

export default function App() {
  return <StatusPage />;
}
